export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-01-16T18:28:34.729Z",
    "Language": "pl-PL",
    "Messages": {
        "Administracja": "",
        "Aktualizacja: {0}": "",
        "Alias": "",
        "Alias został przepięty.": "",
        "Anuluj": "",
        "Docs": "",
        "Dodaj": "",
        "Dodaj słowo": "",
        "Dodaj synonimy": "",
        "dodane i edytowane przeze mnie": "",
        "Edytuj": "",
        "Health": "",
        "Indeks": "",
        "Indeks został usunięty.": "",
        "Lista indeksów": "",
        "Mappingi": "",
        "Nazwa aliasu": "",
        "Po jednym synonimie w wierszu": "",
        "Pokaż tylko moje dokumenty": "",
        "Posiada załączniki": "",
        "Potwierdzenie usunięcia": "",
        "Przebudowanie indeksów": "",
        "Przebudowanie indeksównnOperacja może trwać od kilku sekund do kilku godzin w zależności od rozmiaru indeksów.nnNależy używać tylko w przypadku konieczności zaaplikowania zmian dokonanych w słownikach synonimów lub słów wykluczonych.": "",
        "Przeindeksowanie danych": "",
        "Przeindeksowanie danychnnOperacja może trwać od kilku sekund do kilku godzin w zależności od ilości danych w bazie.nnNależy używać tylko w przypadku zauważenia braku danych w indeksach.": "",
        "Przepnij alias": "",
        "Rozmiar": "",
        "Słowa wykluczone": "",
        "Słowo": "",
        "Słowo bazowe": "",
        "Słowo wykluczone": "",
        "Słowo zostało dodane.": "",
        "Słowo zostało usunięte.": "",
        "Słowo zostało zaktualizowane.": "",
        "Status": "",
        "Synonimy": "",
        "Synonimy zostały dodane.": "",
        "Synonimy zostały usunięte.": "",
        "Synonimy zostały zaktualizowane.": "",
        "System": "",
        "Szczegóły": "",
        "Szukaj we wszystkich wersjach": "",
        "Szukane słowo": "",
        "tylko dokumenty wersjonowane": "",
        "Ustawienia": "",
        "Usunięcie indeksunnOperacja jest nieodwracalna. Czy na pewno chcesz usunąć wybrany indeks?": "",
        "Usuń": "",
        "Usuń indeks": "",
        "Wyszukiwanie": "",
        "Zadanie przebudowania indeksów zostało rozpoczęte.": "",
        "Zadanie przeindeksowania danych zostało rozpoczęte.": "",
        "Zamknij": "",
        "Zapisz": "",
        "Zmiany zaczną obowiązywać dopiero po przebudowaniu indeksów.": ""
    }
};
